import '../../sass/layout/sections/IG-carousel.scss';

import Swiper, {
  Navigation,
  Autoplay
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';

// const igCarousel = document.getElementById('igCarousel');

// if (igCarousel) {
//   const prevEl = document.querySelector('.ig-carousel .swiper-button-prev');
//   const nextEl = document.querySelector('.ig-carousel .swiper-button-next');

//   let options = {
//     modules: [Navigation, Autoplay],
//     loop: false,
//     slidesPerView: 'auto',
//     speed: 1000,
//     navigation: {
//       prevEl,
//       nextEl,
//     },
//     autoplay: true,
//     autoplay: {
//       delay: 5000,
//     },
//     breakpoints: {
//       1024: {
//         slidesPerView: 3,
//         slidesPerGroup: 3,
//       }
//     },
//     init: true,
//   }

//   if(window.innerWidth < 1023) {
//     Object.assign(options, {
//       loop: true,
//       centeredSlides: true,
//     })
//   }

//   const swiper = new Swiper(igCarousel, options);

//   swiper.on('slideChange', function (swiper) {
//     myLazyLoad.update();
//   });
  
// }

myLazyLoad.update();
